"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./index.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Node
// Style
var Input = function Input(_ref) {
  var id = _ref.id,
      type = _ref.type,
      style = _ref.style,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      placeholder = _ref.placeholder,
      label = _ref.label,
      surlabel = _ref.surlabel,
      className = _ref.className,
      disabled = _ref.disabled,
      required = _ref.required,
      error = _ref.error,
      prefix = _ref.prefix,
      suffix = _ref.suffix,
      minLength = _ref.minLength,
      maxLength = _ref.maxLength,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur;

  function getLabelGroup() {
    // Input Label
    var inputLabel = /*#__PURE__*/_react.default.createElement("span", {
      className: "shpmtc-input__label-group__label"
    }, label);

    var inputSurlabel = /*#__PURE__*/_react.default.createElement("span", {
      className: "shpmtc-input__label-group__surlabel"
    }, surlabel);

    return /*#__PURE__*/_react.default.createElement("div", {
      className: "shpmtc-input__label-group"
    }, label ? inputLabel : null, surlabel ? inputSurlabel : null);
  }

  function getInputGroup() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "shpmtc-input__group"
    }, prefix || undefined, /*#__PURE__*/_react.default.createElement("input", {
      type: type,
      id: id,
      placeholder: placeholder,
      disabled: disabled,
      value: value,
      defaultValue: defaultValue,
      onChange: onChange,
      onFocus: onFocus,
      onBlur: onBlur,
      required: required,
      minLength: minLength,
      maxLength: maxLength
    }), suffix || undefined);
  }

  function getErrorMsg() {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "shpmtc-input__error-msg"
    }, error);
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    style: style,
    className: "\n        shpmtc-input\n        ".concat(disabled ? 'shpmtc-input--disabled' : '', "\n        ").concat(error ? 'shpmtc-input--error' : '', "\n        ").concat(required ? 'shpmtc-input--required' : '', "\n        ").concat(className, "\n      ")
  }, label || surlabel ? getLabelGroup() : null, getInputGroup(), error ? getErrorMsg() : undefined);
}; // Prop Types


exports.Input = Input;
Input.defaultProps = {
  id: null,
  type: 'text',
  style: null,
  value: null,
  defaultValue: null,
  placeholder: null,
  label: null,
  surlabel: null,
  className: '',
  disabled: false,
  required: false,
  error: null,
  prefix: null,
  suffix: null,
  minLength: null,
  maxLength: null,
  onChange: function onChange() {
    return null;
  },
  onFocus: function onFocus() {
    return null;
  },
  onBlur: function onBlur() {
    return null;
  }
};
Input.propTypes = {
  id: _propTypes.default.string,
  type: _propTypes.default.string,
  style: _propTypes.default.instanceOf(Object),
  value: _propTypes.default.string,
  defaultValue: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  label: _propTypes.default.string,
  surlabel: _propTypes.default.string,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  required: _propTypes.default.bool,
  error: _propTypes.default.string,
  prefix: _propTypes.default.element,
  suffix: _propTypes.default.element,
  minLength: _propTypes.default.number,
  maxLength: _propTypes.default.number,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func
};